function reverse() {
  return function (input) {
    if (angular.isArray(input) && input.length > 1) {
      const result = [];

      for (let i = input.length - 1; i >= 0; i--) {
        result.push(input[i]);
      }
      return result;
    }
    return input;
  };
}

export default reverse;
